import React, { useEffect, useState } from 'react'
import { firestore } from '../../../../firebase';

function EditRound({id, roundId}) {

    const [roundData, setRoundData] = useState();
    const [round, setRound] = useState(1);
    const [numTeams, setNumTeams] = useState(4);
    const [playersPerTeam, setPlayersPerTeam] = useState(4);
    const [date, setDate] = useState("");

    const [message, setMessage] = useState("");

    useEffect(() => {

        try {
            const roundRef = firestore.collection("hostcup").doc(id).collection("rounds").doc(roundId);
            roundRef.onSnapshot(doc => {
                const roundData = {id: doc.id, ...doc.data()}
                setRoundData(roundData)
                setRound(roundData.round);
                setDate(roundData.date);
                setNumTeams(roundData.num_teams);
                setPlayersPerTeam(roundData.players_per_team)
            });
            
        } catch (error) {
            console.log(error)
        }

    }, [id, roundId])

    async function editHandler(e) {
        e.preventDefault();
        try {
            const roundRef = firestore.collection("hostcup").doc(id).collection("rounds").doc(roundId);
            const data = {
                date,
                round, 
                players_per_team: playersPerTeam,
                num_teams: numTeams
            }
            console.log(data, "EDIT DATA")
            roundRef.update(data);
            setMessage("Oppdatert");
        } catch (error) {
            setMessage("Kunne ikke oppdatere")
        }
    }

    return (
        <form onSubmit={editHandler}>

            <label>Runde nr</label>
            <input type="number" className="form-control mb-2" value={round} onChange={e => setRound(e.target.value)} />

            <label>Antall lag</label>
            <input type="number" className="form-control mb-2" value={numTeams} onChange={e => setNumTeams(e.target.value)} />

            <label>Antall spillere per lag</label>
            <input type="number" className="form-control mb-2" value={playersPerTeam} onChange={e => setPlayersPerTeam(e.target.value)} />

            {message && <p>{message}</p>}
            <button className="btn btn-success">Lagre endringer</button>

        </form>
    )

}
export default EditRound